//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import 'vue-awesome/icons/angle-right'
import Icon from 'vue-awesome/components/Icon'
  export default {
      name: "userinfo",
    components:{
      'v-icon':Icon
    },
    computed:{
      // progress:{
      //   get:function(){
      //     if(this.userinfo.progress){
      //       return this.userinfo.progress.split(',');
      //     }else{
      //       return [];
      //     }
      //   },
      // }
    },
    data(){
        return{
          selectIndex:0,
          showPicker:false,
          choosePickerData:'grade',
          pickerData:{
            'grade':[],
            'sex':[
              {id:0,name:'男'},
              {id:1,name:'女'}
            ]
          },
          userinfo:{},
          progressarr:[]
        }
    },
    methods:{
      nianji(id){
        if(id==null){
          return '未选择';
        }
        var filter=this.pickerData.grade.filter((item,index)=>{
          return item.id==id;
        })
        return filter[0]?filter[0].name:'未选择';
      },
      save(){
        this.$vux.loading.show({
          text:'保存中'
        })
        // var p1=this.axios.post('/xcx/User/head',{head:this.userinfo.head});
        // var p2=this.axios.post('/xcx/User/nickName',{'nick_name':this.userinfo.nick_name});
        // var p3=this.axios.post('/xcx/User/others',this.userinfo);
        // Promise.all([p1,p2,p3]).then((res)=>{
        //   console.log(res);
        //   this.$vux.loading.hide();
        // }).catch(_=>{
        //   this.$vux.loading.hide()
        // })
        this.axios.post('/xcx/User/others',this.userinfo).then(res=>{
          this.$vux.loading.hide();
          tis.$vux.toast.show({
            text:'保存成功',
            type:'success'
          })
        }).catch(_=>{
          this.$vux.loading.hide();
        })
      },
      choose(index){
        if(this.progressarr.indexOf(index)!=-1){
          this.progressarr.splice(this.progressarr.indexOf(index),1);
        }else{
          this.progressarr.push(index);
        }
        this.userinfo.progress=this.progressarr.join(',');
      },
      uploadImg(e){
        var file=e.target.files[0];
        console.log(file);
        var fd=new FormData();
        fd.append('file',file);
        this.axios.post('/xcx/User/uploadImg',fd,{
          headers:{
            'Content-Type':'multipart/form-data'
          }
        }).then(res=>{
          this.userinfo.head=res.data.url;
        })
      }
    },
    created() {
        this.axios.post('/xcx/User/intro').then(res=>{
          this.userinfo=res.data.data;
          this.pickerData.grade=res.data.grade;
          this.progressarr=res.data.data.progress?res.data.data.progress.split(','):[];
        })
    }
  }



// WEBPACK FOOTER //
// ./src/components/userinfo/userinfo.vue